import classnames from 'classnames';
import React, { FC } from 'react';
import { MediaType } from '../../../../../constants/MediaType';
import { FileThumbnail } from '../../../../common';
import styles from './GalleryFileThumbnail.scss';
import { IOuter } from './GalleryFileThumbnail.types';

const selectThumbnailWrapperClassName = (mediaType) => {
  switch (mediaType) {
    case MediaType.Picture:
    case MediaType.SecurePicture:
    case MediaType.Video:
    case MediaType.SecureVideo:
    case MediaType.VectorArt:
      return styles.thumbnailWithDarkOverlay;

    case MediaType.Music:
    case MediaType.SecureMusic:
    case MediaType.Document:
    case MediaType.SecureDocument:
    case MediaType.Zip:
    case MediaType.SecureZip:
    case MediaType.SWF:
      return styles.thumbnailWithLightOverlay;

    default:
      return '';
  }
};

export const GalleryFileThumbnail: FC<IOuter> = ({
  file,
  width,
  height,
  className,
  labelClassName,
  thumbnailClassName,
  overlayClassName,
  selected,
  children,
  controls,
  thumbnailBackground,
  thumbnailSize,
  saveRef,
}) => (
  <div
    className={classnames(
      styles.thumbnailWrapper,
      selectThumbnailWrapperClassName(file.mediaType),
      { [styles.selected]: selected },
      className,
    )}
    ref={saveRef}
    data-hook="gallery-file-thumbnail"
  >
    <FileThumbnail
      className={classnames(styles.thumbnail, thumbnailClassName)}
      file={file}
      width={width}
      height={height}
      labelClassName={labelClassName}
      thumbnailBackground={thumbnailBackground}
      thumbnailSize={thumbnailSize}
    />
    <div className={classnames(styles.overlay, overlayClassName)} data-hook="gallery-file-thumbnail-overlay">
      <div className={styles.thumbnailControls}>{controls}</div>
      <div className={styles.actionsRow}>{children}</div>
    </div>
  </div>
);
